import '@adyen/adyen-web/dist/adyen.css'
import Spinner from 'parkdepot-shared/components/Spinner'
import { useStyletron } from 'parkdepot-shared/theme'
import React, { FC, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { CheckoutContext } from '../../context/CheckoutContext/checkout.context'
import { LotViewName } from '../../types/lot.interface'
import { DropinWrapper, ErrorContainer, WarningIcon, WarningText, WarningTextContainer } from './Dropin.style'
import { IDropinProps } from './types'

const DropIn: FC<IDropinProps> = ({ dropInRef, dropin, error, showTerms = true }) => {
    const { t } = useTranslation()
    const [css] = useStyletron()
    const { checkout } = useContext(CheckoutContext)

    useEffect(() => {
        if (!dropInRef.current || !dropin) return

        dropin.mount(dropInRef.current)

        return () => {
            dropin.unmount()
        }
    }, [dropin, dropInRef])

    if (!dropin && !error) return <Spinner theme="primary" size="xl" />
    if (error) return <ErrorContainer>{t('errors.checkout.dropIn.sessionError')}</ErrorContainer>

    return (
        <>
            {checkout?.lotCheckoutType === LotViewName.SUBSCRIPTION && (
                <DropinWrapper>
                    <WarningTextContainer>
                        <WarningIcon className="wemolo-warning-circle" aria-hidden="true" />
                        <WarningText>{t('checkout.subscriptions.warningText')}</WarningText>
                    </WarningTextContainer>
                </DropinWrapper>
            )}
            <div id="dropin-container" ref={dropInRef} className={css({ width: '100%' })} />
        </>
    )
}

export default DropIn
